<div class="boxes-container">
  <div class="boxes" *ngFor="let box of [].constructor(boxesLength); let i = index">
    <input
      class="boxes__input"
      id="input{{ i }}"
      [type]="autoFocus ? (allowAlphanumeric ? 'text' : 'tel') : 'text'"
      [attr.inputmode]="autoFocus ? (allowAlphanumeric ? 'text' : 'numeric') : null"
      [attr.pattern]="autoFocus && !allowAlphanumeric ? '[0-9]*' : null"
      maxlength="1"
      [ngModel]="inputs['input' + i]"
      (focus)="onInputFocus($event)"
      (input)="onInputChange(i)"
    />
  </div>
</div>
